"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cornerToStyle = exports.objFromKeys = void 0;
/** Auxilary function to shorten code */
function objFromKeys(keys, fun) {
    return keys.reduce((obj, key) => ({ ...obj, [key]: fun(key) }), {});
}
exports.objFromKeys = objFromKeys;
// eslint-disable-next-line consistent-return
function cornerToStyle(corner, alternative) {
    switch (corner) {
        case 'topLeft':
            return alternative ? 'borderTopStartRadius' : 'borderTopLeftRadius';
        case 'topRight':
            return alternative ? 'borderTopEndRadius' : 'borderTopRightRadius';
        case 'bottomLeft':
            return alternative ? 'borderBottomStartRadius' : 'borderBottomLeftRadius';
        case 'bottomRight':
            return alternative ? 'borderBottomEndRadius' : 'borderBottomRightRadius';
        default:
            return alternative ? 'borderBottomEndRadius' : 'borderBottomRightRadius';
    }
}
exports.cornerToStyle = cornerToStyle;
